import React from 'react';
import {
    Route,
    Redirect,
    RouteProps,
} from 'react-router-dom';
import * as FeatherIcon from 'react-feather';
import { checkRole } from '../helpers/Roles';

import { isUserAuthenticated } from '../helpers/authUtils';
import { startsWith } from 'lodash';
import OrderList from '../pages/order/OrderList';
import OrderAdd from '../pages/order/OrderAdd';
import ProductList from '../pages/product/ProductList';
import ProductAdd from '../pages/product/ProductAdd';
import OrderDetail from '../pages/order/OrderDetail';
import SupplierAdd from '../pages/supplier/SupplierAdd';
import SupplierList from '../pages/supplier/SupplierList';
import StockimportAdd from '../pages/stockimport/StockimportAdd';
import StockimportList from '../pages/stockimport/StockimportList';
import StockrequestAdd from '../pages/stockrequest/StockrequestAdd';
import StockrequestList from '../pages/stockrequest/StockrequestList';
import PaymentList from '../pages/payment/PaymentList';
import CashbookList from '../pages/cashbook/CashbookList';
import TypereceiptsList from '../pages/typereceipts/TypereceiptsList';
import ProductBatchList from '../pages/product/ProductBatchList';
import PriceConfig from '../pages/setting/PriceConfig';
import StockTransferList from '../pages/stocktransfer/StockTransferList';
import StockTransferAdd from '../pages/stocktransfer/StockTransferAdd';
import StockReturnList from '../pages/stockreturn/StockReturnList';
import StockReturnAdd from '../pages/stockreturn/StockReturnAdd';
import StockCancelList from '../pages/stockcancel/StockCancelList';
import StockCancelAdd from '../pages/stockcancel/StockCancelAdd';
import SettingAdvanced from '../pages/setting/SettingAdvanced';
import RankConfig from '../pages/setting/RankConfig';
import { basePOSUrl } from '../constants/environment';
import RolesList from '../pages/roles/RolesList';
import RolesAdd from '../pages/roles/RolesAdd';
import Shift from '../pages/shift/Shift';
import OverviewReport from '../pages/report/OverviewReport';

// auth
const Login = React.lazy(() => import('../pages/auth/Login'));
const Logout = React.lazy(() => import('../pages/auth/Logout'));
const LogoutAndRegister = React.lazy(() => import('../pages/auth/LogoutAndRegister'));
const Register = React.lazy(() => import('../pages/auth/Register'));
const ForgetPassword = React.lazy(() => import('../pages/auth/ForgetPassword'));
const CheckForgetPassword = React.lazy(() => import('../pages/auth/CheckForgetPassword'));
const ComfirmPassword = React.lazy(() => import('../pages/auth/ComfirmPassword'));
const ImportPassword = React.lazy(() => import('../pages/auth/ImportPassword'));
const Confirm = React.lazy(() => import('../pages/auth/Confirm'));
const Profiles = React.lazy(() => import('../pages/auth/Profiles'));
const BasisCreate = React.lazy(() => import('../pages/auth/BasisCreate'));
// notFound
const NotFound = React.lazy(() => import('../pages/dashboard/NotFound'));
// dashboard

// MeidicalBasis 
const MedicalBasis = React.lazy(() => import('../pages/basis/MedicalBasis'));
const MedicalAdd = React.lazy(() => import('../pages/basis/MedicalAdd'));
const MedicalDetail = React.lazy(() => import('../pages/basis/MedicalDetail'));

// Custommer
const CustomerList = React.lazy(() => import('../pages/customer/CustomerList'));
const CustomerAdd = React.lazy(() => import('../pages/customer/CustomerAdd'));
const CustomerOderHistory = React.lazy(() => import('../pages/customer/components/OrderHistory'));

// User 
const UserList = React.lazy(() => import('../pages/user/UserList'));
const UserAdd = React.lazy(() => import('../pages/user/UserAdd'));

// UserTitle 
const UserTitleList = React.lazy(() => import('../pages/usertitle/UserTitleList'));
const UserTitleAdd = React.lazy(() => import('../pages/usertitle/UserTitleAdd'));

// Department 
const DepartmentList = React.lazy(() => import('../pages/department/DepartmentList'));
const DepartmentAdd = React.lazy(() => import('../pages/department/DepartmentAdd'));

// Department 
const ConclusionList = React.lazy(() => import('../pages/conclusion/ConclusionList'));
const ConclusionAdd = React.lazy(() => import('../pages/conclusion/ConclusionAdd'));

// Examination
const PrescriptionList = React.lazy(() => import('../pages/prescription/PrescriptionList'));
const PrescriptionAdd = React.lazy(() => import('../pages/prescription/PrescriptionAdd'));

// Examination
const ExaminationList = React.lazy(() => import('../pages/examination/ExaminationList'));
const ExaminationAdd = React.lazy(() => import('../pages/examination/ExaminationAdd'));

// Reception 
const ReceptionList = React.lazy(() => import('../pages/reception/ReceptionList'));
const ReceptionAdd = React.lazy(() => import('../pages/reception/ReceptionAdd'));
const ReceptionAddBooking = React.lazy(() => import('../pages/reception/ReceptionAddBooking'));

//Banks
const BankList = React.lazy(() => import('../pages/bank/BankList'));
const BankDetail = React.lazy(() => import('../pages/bank/BankDetail'));

//Wortime
const Wortime = React.lazy(() => import('../pages/worktime/Worktime'));

// Service 
const ServiceList = React.lazy(() => import('../pages/service/ServiceList'));
const ServiceAdd = React.lazy(() => import('../pages/service/ServiceAdd'));

// Service 
const DesignationList = React.lazy(() => import('../pages/designation/DesignationList'));
const DesignationAdd = React.lazy(() => import('../pages/designation/DesignationAdd'));

// Receipts 
const ReceiptsList = React.lazy(() => import('../pages/receipts/ReceiptsList'));

//Setting
const Setting = React.lazy(() => import('../pages/setting/Setting'));

// Category 
const CategoryList = React.lazy(() => import('../pages/category/CategoryList'));
const CategoryAdd = React.lazy(() => import('../pages/category/CategoryAdd'));

// Fundaccount
const FundaccountList = React.lazy(() => import('../pages/fundaccount/FundaccountList'));
const FundaccountAdd = React.lazy(() => import('../pages/fundaccount/FundaccountAdd'));

// Food 
const FoodList = React.lazy(() => import('../pages/food/FoodList'));

// ServicePack
const ServicePackList = React.lazy(() => import('../pages/servicepark/ServicePackList'));
const ServicePackAdd = React.lazy(() => import('../pages/servicepark/ServicePackAdd'));

// ServicePackage
const ServicePackageAdd = React.lazy(() => import('../pages/servicePackage/ServicePackageAdd'));
const ServicePackageList = React.lazy(() => import('../pages/servicePackage/ServicePackageList'));

// PrintedTicked
// const ServicePackageAdd = React.lazy(() => import('../pages/servicePackage/ServicePackageAdd'));
const PrintedTickedList = React.lazy(() => import('../pages/printedTicket/PrintedTicketList'));

// Presenter
const PresenterList = React.lazy(() => import('../pages/presenter/PresenterList'));

// Menu consultation
const MenuConsulationList = React.lazy(() => import('../pages/menuConsultation/MenuConsulationList'));
const MenuConsulationAdd = React.lazy(() => import('../pages/menuConsultation/MenuConsulationAdd'));

interface PrivateRouteProps extends RouteProps {
    component: any;
    roles: any;
    user: any;
    access_token: string;
    path: string;
    dataFromRouter?: any
}

const PrivateRoute = (props: PrivateRouteProps) => {
    const { component: Component, roles, user, access_token, path, dataFromRouter, ...rest } = props;
    console.log('userxxaa', props)
    return (
        <Route
            {...rest}
            render={props => {
                if (startsWith(path, '/iframes')) {
                    return <Component {...props} dataFromRouter={dataFromRouter} />;
                }
                if (!isUserAuthenticated() || !access_token) {
                    // not logged in so redirect to login page with the return url
                    return <Redirect to={{ pathname: '/account/login', state: { from: props.location } }} />;
                }
                // else if(user && user?.status == 0) {
                //     return <Redirect to={{ pathname: '/account/forget-password', state: { from: props.location } }} />;
                // } 
                // else if(user && user?.branch?.total == 0) {
                //     return <Redirect to={{ pathname: '/account/basis-create', state: { from: props.location } }} />;
                // }
                return <Component {...props} dataFromRouter={dataFromRouter} />;
                if (checkRole(user?.roles, roles, user?.role)) {
                    return <Component {...props} dataFromRouter={dataFromRouter} />;
                } else {
                    return <Redirect to={{ pathname: '/account' }} />;
                }
                // const role = user?.roles?user?.roles[0]:'anonymous'
                // // check if route is restricted by role
                // // console.log('PrivateRoute',roles,role,user,access_token)
                // if (roles && roles.indexOf(role) === -1) {
                //     // role not authorised so redirect to home page
                //     return <Redirect to={{ pathname: '/account' }} />;
                // }

                // // authorised so return component
                // return <Component {...props} />;
            }}
        />
    );
};

// root routes
const rootRoute = {
    path: '/',
    exact: true,
    component: () => <Redirect to="/" />,
    route: PrivateRoute,
};

// Auth
const authRoutes = {
    path: '/account',
    name: 'Auth',
    children: [
        {
            path: '/account/login',
            name: 'Login',
            component: Login,
            route: Route,
        },
        {
            path: '/account/logout',
            name: 'Logout',
            component: Logout,
            route: Route,
        },
        {
            path: '/account/register',
            name: 'Register',
            component: Register,
            route: Route,
        },
        {
            path: '/account/confirm',
            name: 'Confirm',
            component: Confirm,
            route: Route,
        },
        {
            path: '/account/logoutAndRegister',
            name: 'Logout && Register',
            component: LogoutAndRegister,
            route: Route,
        },
        {
            path: '/account/forget-password',
            name: 'Forget Password',
            component: ForgetPassword,
            route: Route,
        },
        {
            path: '/account/check-forget-password',
            name: 'Check Forget Password',
            component: CheckForgetPassword,
            route: Route,
        },
        {
            path: '/account/comfirm-password',
            name: 'Comfirm Password',
            component: ComfirmPassword,
            route: Route,
        },
        {
            path: '/account/import-password',
            name: 'Comfirm Password',
            component: ImportPassword,
            route: Route,
        },
        {
            path: '/account/basis-create',
            name: 'BasisCreate',
            component: BasisCreate,
            route: Route,
        },
        {
            path: '/account',
            name: 'Profile',
            component: Profiles,
            route: PrivateRoute,
        },
    ],
};

const orderRoutes = {
    header: 'BÁN HÀNG',
    headerRoles: ['viewListOrders', 'viewOrders', 'addOrders', 'editOrders', 'deleteOrders', 'statusOrders', 'addOrdersPOS'],
    path: '/order',
    pathParam: '/order/list',
    name: 'Đơn hàng',
    icon: FeatherIcon.ShoppingBag,
    roles: ['viewListOrders'],
    children: [
        {
            path: '/order/list',
            name: 'Danh sách đơn hàng',
            component: OrderList,
            route: PrivateRoute,
            roles: ['viewListOrders'],
            hide: true
        },
        {
            pathParam: '/orderpos/:id/:action',
            component: OrderDetail,
            route: PrivateRoute,
            roles: ['viewOrders', 'addOrders', 'editOrders', 'deleteOrders', 'statusOrders'],
            hide: true
        },
        {
            pathParam: '/order/:id/:action',
            component: OrderAdd,
            route: PrivateRoute,
            roles: ['viewOrders', 'addOrders', 'editOrders', 'deleteOrders', 'statusOrders'],
            hide: true
        },
        {
            pathParam: '/order/:id/',
            component: OrderAdd,
            route: PrivateRoute,
            roles: ['viewOrders', 'addOrders', 'editOrders', 'deleteOrders', 'statusOrders'],
            hide: true,
        },
    ]
};

const prescriptionRoutes = {
    headerRoles: ['viewListPrescription', 'viewPrescription', 'addPrescription', 'editPrescription', 'deletePrescription', 'statusPrescription'],
    path: '/prescription',
    pathParam: '/prescription/list',
    name: 'Kê đơn',
    icon: FeatherIcon.ShoppingBag,
    roles: ['viewListPrescription'],
    children: [
        {
            path: '/prescription/list',
            name: 'Danh sách đơn hàng',
            component: PrescriptionList,
            route: PrivateRoute,
            roles: ['viewListPrescription'],
            hide: true
        },
        {
            path: '/prescription/add',
            component: PrescriptionAdd,
            route: PrivateRoute,
            roles: ['viewListPrescription', 'viewPrescription', 'addPrescription', 'editPrescription', 'deletePrescription', 'statusPrescription'],
            hide: true,
        },
        {
            pathParam: '/prescription/:id/:action',
            component: PrescriptionAdd,
            route: PrivateRoute,
            roles: ['viewListPrescription', 'viewPrescription', 'addPrescription', 'editPrescription', 'deletePrescription', 'statusPrescription'],
            hide: true,
        },
        {
            pathParam: '/prescription/:id',
            component: PrescriptionAdd,
            roles: ['viewListPrescription', 'viewPrescription', 'addPrescription', 'editPrescription', 'deletePrescription', 'statusPrescription'],
            route: PrivateRoute,
            hide: true,
        },
    ]
};

const posRoutes = {
    path: basePOSUrl,
    name: 'Bán hàng',
    isRefLink: true,
    roles: ['addOrdersPOS'],
    icon: FeatherIcon.Clipboard,
};

const servicePackage = {
    headerRoles: ['viewListPrescription', 'viewPrescription', 'addPrescription', 'editPrescription', 'deletePrescription', 'statusPrescription'],
    path: '/packageorder',
    pathParam: '/packageorder/list',
    name: 'Gói thẻ dịch vụ',
    icon: FeatherIcon.ShoppingBag,
    roles: ['viewListOrderspackage'],
    children: [
        {
            path: '/packageorder/list',
            name: 'Danh sách gói thẻ dịch vụ',
            component: ServicePackageList,
            route: PrivateRoute,
            roles: ['viewListOrderspackage'],
            hide: true
        },
        {
            path: '/packageorder/add',
            component: ServicePackageAdd,
            route: PrivateRoute,
            roles: ['viewListOrderspackage', 'viewOrderspackage', 'addOrderspackage', 'editOrderspackage', 'deleteOrderspackage', 'statusOrderspackage'],
            hide: true,
        },
        {
            pathParam: '/packageorder/:id/:action',
            component: ServicePackageAdd,
            route: PrivateRoute,
            roles: ['viewListOrderspackage', 'viewOrderspackage', 'addOrderspackage', 'editOrderspackage', 'deleteOrderspackage', 'statusOrderspackage'],
            hide: true,
        },
        {
            pathParam: '/packageorder/:id',
            component: ServicePackageAdd,
            roles: ['viewListOrderspackage', 'viewOrderspackage', 'addOrderspackage', 'editOrderspackage', 'deleteOrderspackage', 'statusOrderspackage'],
            route: PrivateRoute,
            hide: true,
        },
    ]
};

const CustomerRoutes = {
    header: 'ĐỐI TÁC',
    headerRoles: ['viewListCustomer', 'viewCustomer', 'addCustomer', 'editCustomer', 'deleteCustomer', 'statusCustomer', 'viewListSupplier', 'viewSupplier', 'addSupplier', 'editSupplier', 'deleteSupplier', 'statusSupplier'],
    path: '/customer',
    pathParam: '/customer/list',
    name: 'Khách hàng',
    icon: FeatherIcon.Users,
    roles: ['viewListCustomer'],
    children: [
        {
            path: '/customer/list',
            component: CustomerList,
            route: PrivateRoute,
            roles: ['viewListCustomer'],
            hide: true,
        },
        {
            path: '/customer/add',
            component: CustomerAdd,
            route: PrivateRoute,
            roles: ['viewCustomer', 'addCustomer', 'editCustomer', 'deleteCustomer', 'statusCustomer'],
            hide: true,
        },
        {
            pathParam: '/customer/oderhistory/:id/:action',
            component: CustomerOderHistory,
            route: PrivateRoute,
            roles: ['viewCustomer', 'addCustomer', 'editCustomer', 'deleteCustomer', 'statusCustomer'],
            hide: true,
        },

        {
            pathParam: '/customer/:id/:action',
            component: CustomerAdd,
            route: PrivateRoute,
            roles: ['viewCustomer', 'addCustomer', 'editCustomer', 'deleteCustomer', 'statusCustomer'],
            hide: true,
        },
        {
            pathParam: '/customer/:id',
            component: CustomerAdd,
            route: PrivateRoute,
            roles: ['viewCustomer', 'addCustomer', 'editCustomer', 'deleteCustomer', 'statusCustomer'],
            hide: true,
        },

    ]
};

const supplierRoutes = {
    path: '/supplier',
    pathParam: '/supplier/list',
    name: 'Nhà cung cấp',
    icon: FeatherIcon.Layers,
    roles: ['viewListSupplier'],
    children: [
        {
            path: '/supplier/list',
            component: SupplierList,
            route: PrivateRoute,
            roles: ['viewListSupplier'],
            hide: true,
        },
        {
            path: '/supplier/add',
            component: SupplierAdd,
            route: PrivateRoute,
            roles: ['viewSupplier', 'addSupplier', 'editSupplier', 'deleteSupplier', 'statusSupplier'],
            hide: true,
        },
        {
            pathParam: '/supplier/:id/:action',
            component: SupplierAdd,
            route: PrivateRoute,
            roles: ['viewSupplier', 'addSupplier', 'editSupplier', 'deleteSupplier', 'statusSupplier'],
            hide: true,
        },
        {
            pathParam: '/supplier/:id',
            component: SupplierAdd,
            route: PrivateRoute,
            roles: ['viewSupplier', 'addSupplier', 'editSupplier', 'deleteSupplier', 'statusSupplier'],
            hide: true,
        },


    ]
};

const accountRoutes = {
    header: 'CÀI ĐẶT',
    path: '/account',
    name: 'Thông tin tài khoản',
    icon: FeatherIcon.FileText,
};

const receptionRoutes = {
    header: 'KHÁM BỆNH',
    headerRoles: ['viewListBooking', 'viewListWelcome', 'viewListExamination', 'viewListExamination', 'viewListDesignation', 'viewListConsultationMenu'],
    path: '/reception',
    pathParam: '/reception/list',
    name: 'Tiếp đón',
    icon: FeatherIcon.Calendar,
    roles: ['viewListBooking', 'viewListWelcome', 'viewListExamination'],
    children: [
        {
            path: '/reception/list',
            component: ReceptionList,
            route: PrivateRoute,
            roles: ['viewListBooking', 'viewListWelcome'],
            hide: true,
        },
        {
            pathParam: '/reception/booking/:id/:action',
            component: ReceptionAddBooking,
            route: PrivateRoute,
            roles: ['viewBooking', 'editBooking', 'deleteBooking', 'statusBooking'],
            hide: true,
        },
        {
            pathParam: '/reception/booking/:id',
            component: ReceptionAddBooking,
            route: PrivateRoute,
            roles: ['viewBooking', 'editBooking', 'deleteBooking', 'statusBooking'],
            hide: true,
        },
        {
            path: '/reception/addBooking',
            component: ReceptionAddBooking,
            route: PrivateRoute,
            roles: ['addBooking'],
            hide: true,
        },
        {
            path: '/reception/add',
            component: ReceptionAdd,
            route: PrivateRoute,
            roles: ['addWelcome'],
            hide: true,
        },
        {
            pathParam: '/reception/:id/:action',
            component: ReceptionAdd,
            route: PrivateRoute,
            roles: ['viewBooking', 'editBooking', 'deleteBooking', 'statusBooking', 'viewWelcome', 'editWelcome', 'deleteWelcome', 'statusWelcome'],
            hide: true,
        },
        {
            pathParam: '/reception/:id',
            component: ReceptionAdd,
            route: PrivateRoute,
            roles: ['viewBooking', 'editBooking', 'deleteBooking', 'statusBooking', 'viewWelcome', 'editWelcome', 'deleteWelcome', 'statusWelcome'],
            hide: true,
        },


    ]
};

const designationRoutes = {
    path: '/designation',
    pathParam: '/designation/list',
    name: 'Dịch vụ chỉ định',
    icon: FeatherIcon.FileText,
    roles: ['viewListDesignation'],
    children: [
        {
            path: '/designation/list',
            component: DesignationList,
            route: PrivateRoute,
            hide: true,
            roles: ['viewListDesignation'],
        },
        {
            path: '/designation/add',
            component: DesignationAdd,
            route: PrivateRoute,
            hide: true,
            roles: ['viewDesignation', 'addDesignation', 'editDesignation', 'stautsDesignation', 'statusDesignation'],
        },
        {
            pathParam: '/designation/:id/:action',
            component: DesignationAdd,
            route: PrivateRoute,
            roles: ['viewDesignation', 'addDesignation', 'editDesignation', 'stautsDesignation', 'statusDesignation'],
            hide: true,
        },
        {
            pathParam: '/designation/:id',
            component: DesignationAdd,
            route: PrivateRoute,
            roles: ['viewDesignation', 'addDesignation', 'editDesignation', 'stautsDesignation', 'statusDesignation'],
            hide: true,
        },
    ]
};
const printedtickedRoutes = {
    path: '/printedticket',
    pathParam: '/printedticket/list',
    name: 'Quản lý in phiếu',
    icon: FeatherIcon.FileText,
    roles: ['viewListPrintedTicket'],
    children: [
        {
            path: '/printedticket/list',
            component: PrintedTickedList,
            route: PrivateRoute,
            hide: true,
            roles: ['viewListPrintedTicket', 'addPrintedTicket' ],
        },
    ]
};

const examinationRoutes = {
    path: '/examination',
    pathParam: '/examination/list',
    name: 'Phiếu khám',
    icon: FeatherIcon.FileText,
    roles: ['viewListExamination'],
    children: [
        {
            path: '/examination/list',
            component: ExaminationList,
            route: PrivateRoute,
            hide: true,
            roles: ['viewListExamination'],
        },
        {
            path: '/examination/add',
            component: ExaminationAdd,
            route: PrivateRoute,
            roles: ['viewExamination', 'addExamination', 'editExamination', 'deleteExamination', 'deleteExamination'],
            hide: true,
        },
        {
            pathParam: '/examination/:id/:action',
            component: ExaminationAdd,
            route: PrivateRoute,
            roles: ['viewExamination', 'addExamination', 'editExamination', 'deleteExamination', 'deleteExamination'],
            hide: true,
        },
        {
            pathParam: '/examination/:id',
            component: ExaminationAdd,
            route: PrivateRoute,
            roles: ['viewExamination', 'addExamination', 'editExamination', 'deleteExamination', 'deleteExamination'],
            hide: true,
        },
        // {
        //     path: '/prescription/add',
        //     component: PrescriptionAdd,
        //     route: PrivateRoute,
        //     roles: [ 'viewListPrescription', 'viewPrescription', 'addPrescription', 'editPrescription','deletePrescription', 'statusPrescription'],
        //     hide:true,
        // },
        // {
        //     pathParam: '/prescription/:id/:action',
        //     component: PrescriptionAdd,
        //     route: PrivateRoute,
        //     roles: [ 'viewListPrescription', 'viewPrescription', 'addPrescription', 'editPrescription','deletePrescription', 'statusPrescription'],
        //     hide:true,
        // },
        // {
        //     pathParam: '/prescription/:id',
        //     component: PrescriptionAdd,
        //     roles: [ 'viewListPrescription', 'viewPrescription', 'addPrescription', 'editPrescription','deletePrescription', 'statusPrescription'],
        //     route: PrivateRoute,
        //     hide:true,
        // },  
    ]
};

const menuConsultation = {
    path: '/menuConsulation',
    pathParam: '/menuConsulation/list',
    name: 'Thực đơn tư vấn',
    icon: FeatherIcon.FileText,
    roles: ['viewListConsultationMenu'],
    children: [
        {
            path: '/menuConsulation/list',
            component: MenuConsulationList,
            route: PrivateRoute,
            hide: true,
            roles: ['viewListConsultationMenu'],
        },
        {
            path: '/menuConsulation/add',
            component: MenuConsulationAdd,
            route: PrivateRoute,
            roles: ['viewListConsultationMenu', 'addConsultationMenu', 'editConsultationMenu', 'statusConsultationMenu', 'statusConsultationMenu'],
            hide: true,
        },
        {
            pathParam: '/menuConsulation/:id/:action',
            component: MenuConsulationAdd,
            route: PrivateRoute,
            roles: ['viewListConsultationMenu', 'addConsultationMenu', 'editConsultationMenu', 'statusConsultationMenu', 'statusConsultationMenu' , 'deleteConsultationMenu'],
            hide: true,
        },
        {
            pathParam: '/menuConsulation/:id/view',
            component: MenuConsulationAdd,
            route: PrivateRoute,
            roles: ['viewListConsultationMenu', 'addConsultationMenu', 'editConsultationMenu', 'statusConsultationMenu', 'statusConsultationMenu'],
            hide: true,
        },
    ]
}

const settingRoutes = {
    path: '/setting',
    pathParam: '/setting/list',
    name: 'Cấu hình',
    icon: FeatherIcon.Settings,
    roles: ['viewListExamination', 'viewWorkTime', 'viewListConclusion', 'addConclusion', 'editConclusion', 'viewConclusion', 'deleteConclusion', 'statusConclusion',
        'addConclusion', 'editConclusion', 'viewConclusion', 'deleteConclusion', 'statusConclusion', 'addConclusion', 'editConclusion', 'viewConclusion', 'deleteConclusion', 'statusConclusion', 'viewListFundaccount', 'addFundaccount', 'editFundaccount', 'viewFundaccount', 'deleteFundaccount', 'statusFundaccount',
        'addFundaccount', 'editFundaccount', 'viewFundaccount', 'deleteFundaccount', 'statusFundaccount', 'addFundaccount', 'editFundaccount', 'viewFundaccount', 'deleteFundaccount', 'statusFundaccount',
        'viewListClinic', 'addClinic', 'viewClinic', 'editClinic', 'deleteClinic', 'statusClinic', 'addClinic', 'viewClinic', 'editClinic', 'deleteClinic', 'statusClinic',
        'addClinic', 'viewClinic', 'editClinic', 'deleteClinic', 'statusClinic', 'viewListBranch', 'addBranch', 'viewBranch', 'editBranch', 'deleteBranch', 'statusBranch',
        'viewListService', 'addService', 'viewService', 'editService', 'deleteService', 'statusService', 'viewListUsertitle', 'addUsertitle', 'viewUsertitle', 'editUsertitle', 'deleteUsertitle',
        'addUsertitle', 'viewUsertitle', 'editUsertitle', 'deleteUsertitle', 'viewListUser', 'addUser', 'viewUser', 'editUser', 'statusUser',
        'viewListTypeReceipts', 'viewListFood', 'viewPriceCosstConfig', 'viewListSalesChannel', 'viewListShippingPartner', 'viewListPaymentMethod', 'viewListCashbookMethod', 'viewCustomerRank',
        'viewListRole', 'addRole', 'viewRole', 'editRole', 'deleteRole', 'statusRole',
    ],
    children: [
        {
            path: '/setting/list',
            component: Setting,
            route: PrivateRoute,
            hide: true,
            roles: ['viewListExamination', 'viewWorkTime', 'viewListConclusion', 'addConclusion', 'editConclusion', 'viewConclusion', 'deleteConclusion', 'statusConclusion',
                'addConclusion', 'editConclusion', 'viewConclusion', 'deleteConclusion', 'statusConclusion', 'addConclusion', 'editConclusion', 'viewConclusion', 'deleteConclusion', 'statusConclusion', 'viewListFundaccount', 'addFundaccount', 'editFundaccount', 'viewFundaccount', 'deleteFundaccount', 'statusFundaccount',
                'addFundaccount', 'editFundaccount', 'viewFundaccount', 'deleteFundaccount', 'statusFundaccount', 'addFundaccount', 'editFundaccount', 'viewFundaccount', 'deleteFundaccount', 'statusFundaccount',
                'viewListClinic', 'addClinic', 'viewClinic', 'editClinic', 'deleteClinic', 'statusClinic', 'addClinic', 'viewClinic', 'editClinic', 'deleteClinic', 'statusClinic',
                'addClinic', 'viewClinic', 'editClinic', 'deleteClinic', 'statusClinic', 'viewListBranch', 'addBranch', 'viewBranch', 'editBranch', 'deleteBranch', 'statusBranch',
                'viewListService', 'addService', 'viewService', 'editService', 'deleteService', 'statusService', 'viewListUsertitle', 'addUsertitle', 'viewUsertitle', 'editUsertitle', 'deleteUsertitle',
                'addUsertitle', 'viewUsertitle', 'editUsertitle', 'deleteUsertitle', 'viewListUser', 'addUser', 'viewUser', 'editUser', 'statusUser',
                'viewListTypeReceipts', 'viewListFood', 'viewPriceCosstConfig', 'viewListSalesChannel', 'viewListShippingPartner', 'viewListPaymentMethod', 'viewListCashbookMethod', 'viewCustomerRank',
                'viewListRole', 'addRole', 'viewRole', 'editRole', 'deleteRole', 'statusRole',
            ],
        },
        {
            name: 'Thời gian làm việc',
            path: '/setting/worktime',
            component: Wortime,
            route: PrivateRoute,
            roles: ['viewWorkTime'],
            hide: true,
        },
        {
            name: 'Quản lý mẫu',
            path: '/setting/conclusion/list',
            component: ConclusionList,
            roles: ['viewListConclusion'],
            route: PrivateRoute,
            hide: true,
        },
        {
            path: '/setting/conclusion/add',
            component: ConclusionAdd,
            roles: ['addConclusion', 'editConclusion', 'viewConclusion', 'deleteConclusion', 'statusConclusion'],
            route: PrivateRoute,
            hide: true,
        },
        {
            pathParam: '/setting/conclusion/:id/:action',
            component: ConclusionAdd,
            roles: ['addConclusion', 'editConclusion', 'viewConclusion', 'deleteConclusion', 'statusConclusion'],
            route: PrivateRoute,
            hide: true,
        },
        {
            pathParam: '/setting/conclusion/:id',
            component: ConclusionAdd,
            roles: ['addConclusion', 'editConclusion', 'viewConclusion', 'deleteConclusion', 'statusConclusion'],
            route: PrivateRoute,
            hide: true,
        },
        {
            path: '/setting/department/list',
            component: DepartmentList,
            route: PrivateRoute,
            roles: ['viewListClinic'],
            hide: true,
        },
        {
            path: '/setting/department/add',
            component: DepartmentAdd,
            roles: ['addClinic', 'viewClinic', 'editClinic', 'deleteClinic', 'statusClinic'],
            route: PrivateRoute,
            hide: true,
        },
        {
            pathParam: '/setting/department/:id/:action',
            component: DepartmentAdd,
            roles: ['addClinic', 'viewClinic', 'editClinic', 'deleteClinic', 'statusClinic'],
            route: PrivateRoute,
            hide: true,
        },
        {
            pathParam: '/setting/department/:id',
            component: DepartmentAdd,
            roles: ['addClinic', 'viewClinic', 'editClinic', 'deleteClinic', 'statusClinic'],
            route: PrivateRoute,
            hide: true,
        },
        {
            path: '/setting/medicalbasis/list',
            component: MedicalBasis,
            route: PrivateRoute,
            hide: true,
            roles: ['viewListBranch'],
        },
        {
            path: '/setting/medicalbasis/add',
            component: MedicalAdd,
            route: PrivateRoute,
            hide: true,
            roles: ['addBranch', 'viewBranch', 'editBranch', 'deleteBranch', 'statusBranch'],
        },
        {
            pathParam: '/setting/medicalbasis/:id/:action',
            component: MedicalAdd,
            route: PrivateRoute,
            roles: ['addBranch', 'viewBranch', 'editBranch', 'deleteBranch', 'statusBranch'],
            hide: true,
        },
        {
            pathParam: '/setting/medicalbasis/:id',
            component: MedicalAdd,
            route: PrivateRoute,
            roles: ['addBranch', 'viewBranch', 'editBranch', 'deleteBranch', 'statusBranch'],
            hide: true,
        },
        {
            path: '/setting/service/list',
            component: ServiceList,
            route: PrivateRoute,
            hide: true,
            roles: ['viewListService'],
        },
        {
            path: '/setting/service/add',
            component: ServiceAdd,
            route: PrivateRoute,
            roles: ['addService', 'viewService', 'editService', 'deleteService', 'statusService'],
            hide: true,
        },
        {
            pathParam: '/setting/service/:id/:action',
            component: ServiceAdd,
            route: PrivateRoute,
            roles: ['addService', 'viewService', 'editService', 'deleteService', 'statusService'],
            hide: true,
        },
        {
            pathParam: '/setting/service/:id',
            component: ServiceAdd,
            route: PrivateRoute,
            roles: ['addService', 'viewService', 'editService', 'deleteService', 'statusService'],
            hide: true,
        },
        {
            path: '/setting/title/list',
            component: UserTitleList,
            route: PrivateRoute,
            roles: ['viewListUsertitle'],
            hide: true,
        },
        {
            path: '/setting/title/add',
            component: UserTitleAdd,
            route: PrivateRoute,
            roles: ['addUsertitle', 'viewUsertitle', 'editUsertitle', 'deleteUsertitle'],
            hide: true,
        },
        {
            pathParam: '/setting/title/:id/:action',
            component: UserTitleAdd,
            route: PrivateRoute,
            roles: ['addUsertitle', 'viewUsertitle', 'editUsertitle', 'deleteUsertitle'],
            hide: true,
        },
        {
            pathParam: '/setting/title/:id',
            component: UserTitleAdd,
            route: PrivateRoute,
            roles: ['addUsertitle', 'viewUsertitle', 'editUsertitle', 'deleteUsertitle'],
            hide: true,
        },
        {
            path: '/setting/user/list',
            component: UserList,
            route: PrivateRoute,
            hide: true,
            roles: ['viewListUser'],
        },
        {
            path: '/setting/user/add',
            component: UserAdd,
            route: PrivateRoute,
            roles: ['addUser', 'viewUser', 'editUser', 'statusUser'],
            hide: true,
        },
        {
            pathParam: '/setting/user/:id/:action',
            component: UserAdd,
            route: PrivateRoute,
            roles: ['addUser', 'viewUser', 'editUser', 'statusUser'],
            hide: true,
        },
        {
            pathParam: '/setting/user/:id',
            component: UserAdd,
            route: PrivateRoute,
            hide: true,
            roles: ['addUser', 'viewUser', 'editUser', 'statusUser'],
        },
        // {
        //     path: '/setting/category/list',
        //     component: CategoryList,
        //     route: PrivateRoute,
        //     hide:true,
        //     roles: [ 'viewListCategory'],
        // },
        // {
        //     path: '/setting/category/add',
        //     component: CategoryAdd,
        //     route: PrivateRoute,
        //     hide:true,
        //     roles: [ 'addCategory', 'viewCategory', 'editCategory', 'deleteCategory', 'statusCategory'],
        // },
        // {
        //     pathParam: '/setting/category/:id/:action',
        //     component: CategoryAdd,
        //     route: PrivateRoute,
        //     roles: [ 'addCategory', 'viewCategory', 'editCategory', 'deleteCategory', 'statusCategory'],
        //     hide:true,
        // },
        // {
        //     pathParam: '/setting/category/:id',
        //     component: CategoryAdd,
        //     route: PrivateRoute,
        //     roles: [ 'addCategory', 'viewCategory', 'editCategory', 'deleteCategory', 'statusCategory'],
        //     hide:true,
        // },
        // {
        //     path: '/setting/product/list',
        //     component: ProductList,
        //     route: PrivateRoute,
        //     hide:true,
        // },
        // {
        //     path: '/setting/product/add',
        //     component: ProductAdd,
        //     route: PrivateRoute,
        //     hide:true,
        // },
        // {
        //     pathParam: '/setting/product/:id/:action',
        //     component: ProductAdd,
        //     route: PrivateRoute,
        //     hide:true,
        // },
        // {
        //     pathParam: '/setting/product/:id',
        //     component: ProductAdd,
        //     route: PrivateRoute,
        //     hide:true,
        // },
        {
            name: 'Phiếu thu chi',
            path: '/setting/typereceipts/list',
            component: TypereceiptsList,
            route: PrivateRoute,
            hide: true,
            roles: ['viewListTypeReceipts'],
        },
        {
            name: 'Thực phẩm',
            path: '/setting/food/list',
            component: FoodList,
            route: PrivateRoute,
            hide: true,
            roles: ['viewListFood'],
        },
        {
            path: '/setting/priceconfig',
            component: PriceConfig,
            route: PrivateRoute,
            hide: true,
            roles: ['viewPriceCosstConfig'],
        },
        {
            path: '/setting/advanced',
            component: SettingAdvanced,
            route: PrivateRoute,
            roles: ['viewListSalesChannel', 'viewListShippingPartner', 'viewListPaymentMethod'],
            hide: true,
        },
        {
            path: '/setting/rankconfig',
            component: RankConfig,
            route: PrivateRoute,
            roles: ['viewCustomerRank'],
            hide: true,
        },
        {
            path: '/setting/roles/list',
            component: RolesList,
            route: PrivateRoute,
            roles: ['viewListRole'],
            hide: true,
        },
        {
            path: '/setting/roles/add',
            component: RolesAdd,
            route: PrivateRoute,
            roles: ['addRole', 'viewRole', 'editRole', 'deleteRole', 'statusRole'],
            hide: true,
        },
        {
            pathParam: '/setting/roles/:id/:action',
            component: RolesAdd,
            route: PrivateRoute,
            roles: ['addRole', 'viewRole', 'editRole', 'deleteRole', 'statusRole'],
            hide: true,
        },
        {
            pathParam: '/setting/roles/:id',
            component: RolesAdd,
            route: PrivateRoute,
            roles: ['addRole', 'viewRole', 'editRole', 'deleteRole', 'statusRole'],
            hide: true,
        },
        {
            name: 'Phân lịch phòng khám',
            path: '/setting/working-shift',
            component: Shift,
            route: PrivateRoute,
            roles: ['viewShift'],
            hide: true,
        },
        {
            name: 'Sổ Quỹ',
            path: '/setting/fundaccount/list',
            component: FundaccountList,
            roles: ['viewListFundaccount'],
            route: PrivateRoute,
            hide: true,
        }, {
            path: '/setting/fundaccount/add',
            component: FundaccountAdd,
            roles: ['addFundaccount', 'editFundaccount', 'viewFundaccount', 'deleteFundaccount', 'statusFundaccount'],
            route: PrivateRoute,
            hide: true,
        },
        {
            pathParam: '/setting/fundaccount/:id/:action',
            component: FundaccountAdd,
            roles: ['addFundaccount', 'editFundaccount', 'viewFundaccount', 'deleteFundaccount', 'statusFundaccount'],
            route: PrivateRoute,
            hide: true,
        },
        {
            pathParam: '/setting/fundaccount/:id',
            component: FundaccountAdd,
            roles: ['addFundaccount', 'editFundaccount', 'viewFundaccount', 'deleteFundaccount', 'statusFundaccount'],
            route: PrivateRoute,
            hide: true,
        },
        // router người giới thiệu
        {
            pathParam: '/setting/presenter/list',
            component: PresenterList,
            roles: ['addFundaccount', 'editFundaccount', 'viewFundaccount', 'deleteFundaccount', 'statusFundaccount'],
            route: PrivateRoute,
            hide: true,
        }


    ]
};

const productRouter = {
    header: 'SẢN PHẨM',
    headerRoles: ['viewListProduct', 'viewListCategory', 'viewListProductBatch', 'viewProductBatch', 'addProductBatch', 'editProductBatch', 'statusProductBatch', 'deleteProductBatch'],
    path: '/product',
    pathParam: '/product/list',
    name: 'Sản phẩm',
    icon: FeatherIcon.Box,
    roles: ['viewListProduct'],
    children: [
        {
            name: 'Sản phẩm',
            path: '/product/list',
            component: ProductList,
            route: PrivateRoute,
            roles: ['viewListProduct'],
            hide: true,
        },
        {
            pathParam: '/product/:id/:action',
            component: ProductAdd,
            route: PrivateRoute,
            roles: ['viewProduct', 'addProduct', 'editProduct', 'deleteProduct', 'statusProduct'],
            hide: true,
        },
        {
            path: '/product/add',
            pathParam: '/product/:id',
            component: ProductAdd,
            route: PrivateRoute,
            roles: ['viewProduct', 'addProduct', 'editProduct', 'deleteProduct', 'statusProduct'],
            hide: true,
        },
    ]
}

const productBatchRouter = {
    path: '/batch',
    pathParam: '/batch',
    name: 'Lô sản phẩm',
    component: ProductBatchList,
    hideWhenUseERPStock: true,
    route: PrivateRoute,
    roles: ['viewListProductBatch', 'viewProductBatch', 'addProductBatch', 'editProductBatch', 'statusProductBatch', 'deleteProductBatch'],
    icon: FeatherIcon.Clipboard,
}

const categoryRouter = {
    path: '/category',
    pathParam: '/category/list',
    name: 'Danh mục',
    icon: FeatherIcon.Folder,
    roles: ['viewListCategory'],
    children: [
        {
            name: 'Danh mục',
            path: '/category/list',
            component: CategoryList,
            route: PrivateRoute,
            roles: ['viewListCategory'],
            hide: true,
        },
        {
            path: '/category/add',
            component: CategoryAdd,
            route: PrivateRoute,
            roles: ['viewCategory', 'addCategory', 'editCategory', 'statusCategory', 'deleteCategory'],
            hide: true,
        },
        {
            pathParam: '/category/:id/:action',
            component: CategoryAdd,
            roles: ['viewCategory', 'addCategory', 'editCategory', 'statusCategory', 'deleteCategory'],
            route: PrivateRoute,
            hide: true,
        },
        {
            pathParam: '/category/:id',
            component: CategoryAdd,
            roles: ['viewCategory', 'addCategory', 'editCategory', 'statusCategory', 'deleteCategory'],
            route: PrivateRoute,
            hide: true,
        }

    ]
}

const ServicePack = {
    path: '/servicepack',
    pathParam: '/servicepack/list',
    name: 'Gói dịch vụ',
    icon: FeatherIcon.Folder,
    roles: ['viewListServicepackage'],
    children: [
        {
            name: 'Gói dịch vụ',
            path: '/servicepack/list',
            component: ServicePackList,
            route: PrivateRoute,
            roles: ['viewListServicepackage'],
            hide: true,
        },
        {
            path: '/servicepack/add',
            component: ServicePackAdd,
            route: PrivateRoute,
            roles: ['viewServicepackage', 'addServicepackage', 'editServicepackage', 'statusServicepackage', 'deleteServicepackage'],
            hide: true,
        },
        {
            pathParam: '/servicepack/:id/:action',
            component: ServicePackAdd,
            roles: ['viewServicepackage', 'addServicepackage', 'editServicepackage', 'statusServicepackage', 'deleteServicepackage'],
            route: PrivateRoute,
            hide: true,
        },
        {
            pathParam: '/servicepack/:id',
            component: ServicePackAdd,
            roles: ['viewServicepackage', 'addServicepackage', 'editServicepackage', 'statusServicepackage', 'deleteServicepackage'],
            route: PrivateRoute,
            hide: true,
        }

    ]
}

const receiptsRoutes = {
    header: 'TÀI CHÍNH',
    headerRoles: ['viewListReceipts', 'viewListPaymentMethod'],
    path: '/receipts',
    pathParam: '/receipts/list',
    name: 'Phiếu thu',
    icon: FeatherIcon.PieChart,
    roles: ['viewListReceipts'],
    children: [
        {
            path: '/receipts/list',
            component: ReceiptsList,
            route: PrivateRoute,
            roles: ['viewListReceipts', 'viewReceipts', 'addReceipts', 'editReceipts', 'deleteReceipts', 'statusReceipts'],
            hide: true,
        }
    ]
};

const paymentRoutes = {
    path: '/payment',
    pathParam: '/payment/list',
    name: 'Phiếu chi',
    icon: FeatherIcon.PieChart,
    roles: ['viewListPayment'],
    children: [
        {
            path: '/payment/list',
            component: PaymentList,
            route: PrivateRoute,
            roles: ['viewListPayment', 'viewPayment', 'addPayment', 'editPayment', 'deletePayment', 'statusPayment'],
            hide: true,
        }
    ]
};

const cashbook = {
    path: '/cashbook',
    pathParam: '/cashbook/list',
    name: 'Sổ quỹ',
    icon: FeatherIcon.Clipboard,
    roles: ['reportFundaccount'],
    children: [
        {
            path: '/cashbook/list',
            component: CashbookList,
            route: PrivateRoute,
            roles: ['reportFundaccount'],
            hide: true,
        }
    ]
};

const stockRequestRoutes = {
    header: 'KHO HÀNG',
    headerRoles: ['viewListStockRequest', 'viewStockRequest', 'viewListStockImport', 'viewStockImport', 'viewListStockTransfer', 'viewStockTransfer', 'viewListStockReturn', 'viewStockReturn', 'viewListStockCancel', 'viewStockCancel'],
    path: '/stockrequest',
    pathParam: '/stockrequest/list',
    name: 'Yêu cầu nhập hàng',
    hideWhenUseERPStock: true,
    icon: FeatherIcon.Server,
    roles: ['viewListStockRequest', 'viewStockRequest'],
    children: [
        {
            path: '/stockrequest/list',
            component: StockrequestList,
            route: PrivateRoute,
            hide: true,
            hideWhenUseERPStock: true,
            roles: ['viewListStockRequest'],
        },
        {
            path: '/stockrequest/add',
            component: StockrequestAdd,
            route: PrivateRoute,
            hide: true,
            hideWhenUseERPStock: true,
            roles: ['viewStockRequest', 'addStockRequest', 'editStockRequest', 'deleteStockRequest', 'statusStockRequest'],
        },
        {
            pathParam: '/stockrequest/:id/:action',
            component: StockrequestAdd,
            route: PrivateRoute,
            hideWhenUseERPStock: true,
            roles: ['viewStockRequest', 'addStockRequest', 'editStockRequest', 'deleteStockRequest', 'statusStockRequest'],
            hide: true,
        },
        {
            pathParam: '/stockrequest/:id',
            component: StockrequestAdd,
            route: PrivateRoute,
            hideWhenUseERPStock: true,
            roles: ['viewStockRequest', 'addStockRequest', 'editStockRequest', 'deleteStockRequest', 'statusStockRequest'],
            hide: true,
        },


    ]
};

const stockImportRoutes = {
    path: '/stockimport',
    pathParam: '/stockimport/list',
    name: 'Nhập hàng',
    icon: FeatherIcon.Layers,
    hideWhenUseERPStock: true,
    roles: ['viewListStockImport', 'viewStockImport'],
    children: [
        {
            path: '/stockimport/list',
            component: StockimportList,
            route: PrivateRoute,
            roles: ['viewListStockImport'],
            hide: true,
            hideWhenUseERPStock: true,
        },
        {
            path: '/stockimport/add',
            component: StockimportAdd,
            route: PrivateRoute,
            roles: ['viewStockImport', 'addStockImport', 'editStockImport', 'deleteStockImport', 'statusStockImport'],
            hide: true,
            hideWhenUseERPStock: true,
        },
        {
            pathParam: '/stockimport/:id/:action',
            component: StockimportAdd,
            route: PrivateRoute,
            roles: ['viewStockImport', 'addStockImport', 'editStockImport', 'deleteStockImport', 'statusStockImport'],
            hide: true,
            hideWhenUseERPStock: true,
        },
        {
            pathParam: '/stockimport/:id',
            component: StockimportAdd,
            route: PrivateRoute,
            hide: true,
            hideWhenUseERPStock: true,
            roles: ['viewStockImport', 'addStockImport', 'editStockImport', 'deleteStockImport', 'statusStockImport'],
        },


    ]
};

const stockTranferRoutes = {
    path: '/stocktransfer',
    pathParam: '/stocktransfer/list',
    name: 'Chuyển kho',
    hideWhenUseERPStock: true,
    icon: FeatherIcon.RefreshCcw,
    roles: ['viewListStockTransfer', 'viewStockTransfer'],
    children: [
        {
            path: '/stocktransfer/list',
            component: StockTransferList,
            route: PrivateRoute,
            hide: true,
            hideWhenUseERPStock: true,
            roles: ['viewListStockTransfer'],
        },
        {
            pathParam: '/stocktransfer/:id/:action',
            component: StockTransferAdd,
            route: PrivateRoute,
            roles: ['viewStockTransfer', 'addStockTransfer', 'editStockTransfer', 'deleteStockTransfer', 'statusStockTransfer'],
            hide: true,
            hideWhenUseERPStock: true,
        },
        {
            path: '/stocktransfer/add',
            pathParam: '/stocktransfer/:id',
            component: StockTransferAdd,
            route: PrivateRoute,
            roles: ['viewStockTransfer', 'addStockTransfer', 'editStockTransfer', 'deleteStockTransfer', 'statusStockTransfer'],
            hide: true,
            hideWhenUseERPStock: true,
        },
    ]
};

const stockReturnRoutes = {
    path: '/stockreturn',
    pathParam: '/stockreturn/list',
    name: 'Trả hàng',
    hideWhenUseERPStock: true,
    icon: FeatherIcon.RotateCcw,
    roles: ['viewListStockReturn', 'viewStockReturn'],
    children: [
        {
            path: '/stockreturn/list',
            component: StockReturnList,
            roles: ['viewListStockReturn'],
            route: PrivateRoute,
            hide: true,
            hideWhenUseERPStock: true,
        },
        {
            pathParam: '/stockreturn/:id/:action',
            component: StockReturnAdd,
            route: PrivateRoute,
            roles: ['viewStockReturn', 'addStockReturn', 'editStockReturn', 'deleteStockReturn', 'statusStockReturn'],
            hide: true,
            hideWhenUseERPStock: true,
        },
        {
            path: '/stockreturn/add',
            pathParam: '/stockreturn/:id',
            component: StockReturnAdd,
            route: PrivateRoute,
            roles: ['viewStockReturn', 'addStockReturn', 'editStockReturn', 'deleteStockReturn', 'statusStockReturn'],
            hide: true,
            hideWhenUseERPStock: true,
        },


    ]
};

const stockCancelRoutes = {
    path: '/stockcancel',
    pathParam: '/stockcancel/list',
    name: 'Xuất hỏng hủy',
    hideWhenUseERPStock: true,
    icon: FeatherIcon.Droplet,
    roles: ['viewListStockCancel'],
    children: [
        {
            path: '/stockcancel/list',
            component: StockCancelList,
            route: PrivateRoute,
            roles: ['viewListStockCancel'],
            hide: true,
            hideWhenUseERPStock: true,
        },
        {
            pathParam: '/stockcancel/:id/:action',
            component: StockCancelAdd,
            route: PrivateRoute,
            roles: ['viewStockCancel', 'editStockCancel', 'addStockCancel', 'deleteStockCancel', 'statusStockCancel'],
            hide: true,
            hideWhenUseERPStock: true,
        },
        {
            path: '/stockcancel/add',
            pathParam: '/stockcancel/:id',
            component: StockCancelAdd,
            route: PrivateRoute,
            roles: ['viewStockCancel', 'editStockCancel', 'addStockCancel', 'deleteStockCancel', 'statusStockCancel'],
            hide: true,
            hideWhenUseERPStock: true,
        },


    ]
};

const reportRoutes = {
    path: '/report/overview',
    pathParam: '/report/overview',
    name: 'Báo cáo tổng quan',
    header: 'BÁO CÁO',
    icon: FeatherIcon.BarChart2,
    component: OverviewReport,
    route: PrivateRoute,
    roles: [
        'overviewReport'
    ]
};

// notFound
const notFoundRoute = {
    path: '*',
    exact: true,
    component: NotFound,
    route: PrivateRoute,
};

const appRoutes = [
    receptionRoutes, examinationRoutes, designationRoutes, 
    // printedtickedRoutes,
    menuConsultation,
    // printedtickedRoutes,
    orderRoutes, prescriptionRoutes, posRoutes, servicePackage,
    receiptsRoutes, paymentRoutes, cashbook,
    CustomerRoutes, supplierRoutes,
    stockRequestRoutes, stockImportRoutes, stockTranferRoutes, stockReturnRoutes, stockCancelRoutes,
    productRouter, productBatchRouter, categoryRouter, ServicePack,
    accountRoutes,
    settingRoutes,
    reportRoutes
];


// flatten the list of all nested routes
interface routesItem {
    children: any
}

const flattenRoutes = (routes?: routesItem[]) => {
    let flatRoutes: any = [];

    routes = routes || [];
    routes.forEach(item => {
        flatRoutes.push(item);
        if (typeof item.children !== 'undefined') {
            flatRoutes = [...flatRoutes, ...flattenRoutes(item.children)];
        }
    });
    return flatRoutes;
};

// All routes
const allRoutes: any = [
    rootRoute,
    ...appRoutes,
    authRoutes,
    notFoundRoute,
];

const authProtectedRoutes = [...appRoutes];
// const authProtectedRoutes = [ ...appRoutes];
const allFlattenRoutes = flattenRoutes(allRoutes);
export { allRoutes, authProtectedRoutes, allFlattenRoutes };
